export default {
  title: '请选择问卷和邮件模板',
  label: {
    questionnaire: '问卷',
    emailTemplate: '邮件模板'
  },
  btn: {
    invite: '邀请'
  },
  message: {
    inviteSuccess: '邀请成功',
    hasInvited: '已邀请过或者已经完成调查问卷',
    inviteFail: '邀请失败'
  }
}
